


















































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { apiStaffDelete, apiStaffStatus, apiStaffBlacklist } from '@/api/staff'

@Component
export default class StaffPane extends Vue {
    @Prop({ type: Array, default: () => [] }) value!: any[]
    @Prop({ type: Object, required: true }) pager!: any
    @Prop({ type: Array, default: () => [] }) workerTypeList!: any[]

    selectedRows: any[] = []

    get tableData () {
      return this.value
    }

    set tableData (val) {
      this.$emit('input', val)
    }

    handleSelectionChange (val: any[]) {
      this.selectedRows = val
    }

    handleEdit (row: any) {
      this.$router.push({ path: '/staff/edit', query: { id: row.id } })
    }

    handleView (row: any) {
      this.$router.push({ path: '/staff/detail', query: { id: row.id } })
    }

    handleCommand (command: string, row: any) {
      switch (command) {
        case 'delete':
          this.handleDelete(row)
          break
        case 'resign':
          this.handleResign(row)
          break
        case 'blacklist':
          this.handleBlacklist(row, 1)
          break
        case 'unblacklist':
          this.handleBlacklist(row, 0)
          break
      }
    }

    handleDelete (row: any) {
      const isOnJob = row.staff_status === 1
      const tip = isOnJob
        ? '该员工当前为在职状态，删除后将解除账号绑定及相关业务关联，且不可恢复。是否继续？'
        : '确定要删除该员工吗？删除后将解除账号绑定及相关业务关联。'
      this.$confirm(tip, '提示', {
        type: 'warning'
      }).then(() => {
        apiStaffDelete({ ids: [row.id] }).then(() => {
          this.$emit('refresh')
        })
      })
    }

    handleResign (row: any) {
      this.$confirm('确定要设置该员工为离职状态吗？', '提示', {
        type: 'warning'
      }).then(() => {
        apiStaffStatus({ id: row.id, staff_status: 2 }).then(() => {
          this.$message.success('操作成功')
          this.$emit('refresh')
        })
      })
    }

    handleBlacklist (row: any, status: number) {
      const action = status === 1 ? '加入黑名单' : '移出黑名单'
      this.$confirm(`确定要${action}吗？`, '提示', {
        type: 'warning'
      }).then(() => {
        apiStaffBlacklist({ id: row.id, is_blacklist: status }).then(() => {
          this.$message.success(`${action}成功`)
          this.$emit('refresh')
        })
      })
    }

    handleSizeChange (size: number) {
      this.pager.size = size
      this.$emit('refresh')
    }

    handleCurrentChange (page: number) {
      this.pager.page = page
      this.$emit('refresh')
    }

    formatCurrency (value: number): string {
      if (!value) {
        return '￥0.00'
      }
      return '￥' + Number(value).toFixed(2)
    }

    formatDate (timestamp: number): string {
      if (!timestamp) {
        return '-'
      }
      const date = new Date(timestamp * 1000)
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
    }

    getEmploymentTypeText (type: number): string {
      const typeMap = ['', '全职直聘', '兼职', '临时工', '外包', '实习生']
      return typeMap[type] || '未知'
    }

    getStaffStatusText (status: number): string {
      const statusMap = ['', '在职', '离职', '停职']
      return statusMap[status] || '未知'
    }

    getStaffStatusTagType (status: number): string {
      const typeMap = ['', 'success', 'info', 'warning']
      return typeMap[status] || ''
    }

    getCurrentStatusText (status: number): string {
      const statusMap = ['', '空闲', '工作中', '休假', '请假']
      return statusMap[status] || '未知'
    }

    getCurrentStatusTagType (status: number): string {
      const typeMap = ['', 'info', 'primary', 'success', 'warning']
      return typeMap[status] || ''
    }
}
